// app.routes.ts
import { Routes } from '@angular/router';
import { MasterComponent } from './modules/master/master.component';
import { LoginComponent } from './modules/login/login.component';
import { HomeComponent } from './modules/home/home.component';
import { BasicDataComponent } from './modules/forms/basic-data/basic-data.component';

export const routes: Routes = [
  { 
    path: '',
    component: MasterComponent,
    children: [
      { path: '', component: LoginComponent },
      { path: '**', component: LoginComponent },
      { path: '', component: HomeComponent },
      { path: '', component: BasicDataComponent }
    ]
  }
];